(() => {
  const desktop = window.matchMedia(
    "(min-width: 990px) and (hover: hover) and (pointer: fine)"
  );
  const initialized = new WeakSet();

  function initializeMenus() {
    document
      .querySelectorAll(
        '.header__inline-menu details[id^="Details-HeaderMenu-"]'
      )
      .forEach((menu) => {
        if (initialized.has(menu)) return;

        const summary = menu.querySelector(":scope > summary");
        if (!summary) return;

        initialized.add(menu);

        let openTimer;
        let closeTimer;

        function cancelTimers() {
          clearTimeout(openTimer);
          clearTimeout(closeTimer);
        }

        function closeMenu() {
          if (menu.open) summary.click();
        }

        summary.addEventListener("pointerenter", (event) => {
          if (!desktop.matches || event.pointerType !== "mouse") return;

          cancelTimers();

          openTimer = setTimeout(() => {
            const navigation = menu.closest(".header__inline-menu");

            navigation
              .querySelectorAll(
                'details[id^="Details-HeaderMenu-"][open]'
              )
              .forEach((otherMenu) => {
                if (otherMenu !== menu) {
                  otherMenu.querySelector(":scope > summary")?.click();
                }
              });

            if (!menu.open) summary.click();
          }, 200);
        });

        menu.addEventListener("pointerenter", () => {
          clearTimeout(closeTimer);
        });

        menu.addEventListener("pointerleave", (event) => {
          if (!desktop.matches || event.pointerType !== "mouse") return;

          cancelTimers();

          closeTimer = setTimeout(() => {
            if (!menu.contains(document.activeElement)) {
              closeMenu();
            }
          }, 300);
        });

        summary.addEventListener("click", cancelTimers);
        menu.addEventListener("keydown", cancelTimers);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeMenus);
  } else {
    initializeMenus();
  }

  document.addEventListener("shopify:section:load", initializeMenus);
})();